import mobileLocationRoute from "./mobilelocation";
import attorneyUploadRoute from "./attorneyupload";
import requestLetterUploadRoute from "./requestletterupload";
export default [
  {
    path: "/",
    component: () => import("@/components/layouts/frontendapp"),
    children: [
      ...mobileLocationRoute,
      ...attorneyUploadRoute,
      ...requestLetterUploadRoute,
      {
        path: "/sp/:client_slug",
        name: "frontend.home",
        component: () => import("@/pages/frontend/home")
      },
      {
        path: "/sp/:client_slug/support",
        name: "frontend.support",
        component: () => import("@/pages/frontend/support")
      },
      {
        path: "/:client_slug/locations/:slug",
        name: "frontend.agent.locations",
        component: () => import("@/pages/frontend/agent/location")
      },
      {
        path: "/:client_slug/appointment/:id/book-now",
        name: "frontend.booknow",
        component: () => import("@/pages/frontend/booknow/index")
      },
      {
        path: "/:client_slug/appointment/success",
        name: "client.appointment.success",
        component: () => import("@/pages/frontend/booknow/final")
      },
      {
        path: "/:client_slug/appointment/view",
        name: "client.appointment.view",
        component: () => import("@/pages/frontend/reportview")
      },
      {
        path: "/:client_slug/appointment/department/citizenship/:id",
        name: "client.appointment.citizenship",
        component: () => import("@/pages/frontend/citizen/index")
      },
      {
        path: "/:client_slug/appointment/disclosure/:id",
        name: "client.appointment.disclosure",
        component: () => import("@/pages/frontend/citizen/index")
      },
      {
        path: "/:client_slug/appointment/biometric-disclosure/:id",
        name: "client.appointment.biometric-disclosure",
        component: () => import("@/pages/frontend/biometric_disclosure.vue")
      },
      {
        path: "/:client_slug/appointment/attorney-email/:id",
        name: "client.appointment.attorney-email",
        component: () => import("@/pages/frontend/attorney_email.vue")
      },
      {
        path: "/:client_slug/appointment/request-letter/:id",
        name: "client.appointment.request-letter",
        component: () => import("@/pages/frontend/request_letter.vue")
      },
      {
        path: "/:client_slug/review",
        name: "client.review",
        component: () => import("@/pages/frontend/review/reviewpage")
      }
      // {
      //   path: "/mobilereg/:slug",
      //   name: "frontend.mobilereg.booknow",
      //   component: () => import("@/pages/frontend/mobilereg/booknow"),
      // },
    ]
  }
];
